import { isDate as isDateFns } from 'date-fns';

export function createDate({
  days,
  hours,
  minutes,
}: {
  days?: number;
  hours?: number;
  minutes?: number;
}) {
  const date = new Date();
  if (days) {
    date.setDate(date.getDate() + days);
  }
  if (hours) {
    date.setDate(date.getHours() + hours);
  }
  if (minutes) {
    date.setDate(date.getMinutes() + minutes);
  }
  return date;
}

export function toDatePickerFormat(date: Date) {
  let year;
  let month;
  let day;
  year = date.getFullYear();
  month = (date.getMonth() + 1).toString().padStart(2, '0');
  day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

// Format a Date for <input type="datetime-local"> in LOCAL timezone (no offset).
// Do NOT use date.toISOString().slice(0, 16) — that yields UTC and the input
// would shift by the user's offset.
export function toDateTimeLocalString(date: Date) {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

// Create a Date object at midnight in the local time zone
export function createDateFromDatePickerString(datePickerString: string) {
  const [year, month, day] = datePickerString.split('-').map(Number); //2023-11-14

  if (year !== undefined && month !== undefined && day !== undefined) {
    return new Date(year, month - 1, day);
  }
}

// A plan's yyyy-mm-dd date as the clinician's own calendar date, e.g. "10/19/2026".
// `new Date('2026-10-19')` is UTC midnight, which is still October 18 west of UTC,
// so every US clinic saw plan dates one day early.
export function formatDatePickerDate(datePickerString: string) {
  return (
    createDateFromDatePickerString(datePickerString)?.toLocaleDateString() ?? datePickerString
  );
}

// The plan list's "start-end" column; a plan with no next plan is "Current".
export function formatPlanDateRange(startDate: string, endDate?: string) {
  return `${formatDatePickerDate(startDate)}-${
    endDate ? formatDatePickerDate(endDate) : 'Current'
  }`;
}

export function addTime(datePickerString: string, time: Date) {
  const hours = String(time.getHours()).padStart(2, '0');
  const minutes = String(time.getMinutes()).padStart(2, '0');
  const seconds = String(time.getSeconds()).padStart(2, '0');

  const dateTimeString = `${datePickerString}T${hours}:${minutes}:${seconds}`;

  return dateTimeString;
}

export function isDate(value: any): value is Date {
  return isDateFns(value);
}

export const dateSortingFn = (rowA: any, rowB: any, columnId: string) => {
  const dateA = new Date(rowA.getValue(columnId));
  const dateB = new Date(rowB.getValue(columnId));
  return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
};
